var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"closing-card",class:{
    '-loading': _vm.loading,
    '-small': _vm.small,
  },style:({ left: _vm.left, top: _vm.top, width: _vm.width, height: _vm.height })},[_c('div',{staticClass:"earmark"}),_vm._v(" "),_c('h1',{staticClass:"title f5"},[_vm._v(_vm._s(_vm.$t('Temporary closure')))]),_vm._v(" "),_c('h2',{staticClass:"time f8"},[_vm._v(_vm._s(_vm.fromToTime))])])}
var staticRenderFns = []

export { render, staticRenderFns }